import React from "react";

const MethodBadge = ({ method = "POST" }) => {
  const themes = {
    GET: "bg-green-100 text-[#1E6C56] border-[#D0E7DF]",
    POST: "bg-blue-100 text-[#0070C1] border-blue-200",
    PUT: "bg-amber-100 text-[#D97706] border-amber-200",
    DELETE: "bg-red-100 text-[#E11D48] border-red-200",
  };

  return (
    <span
      className={`px-2.5 py-1 rounded-md border text-[11px] font-bold uppercase tracking-wider ${
        themes[method] || "bg-gray-100 text-gray-700 border-gray-200"
      }`}
    >
      {method}
    </span>
  );
};

export default MethodBadge;
